const lineage = {
  local: null,
  rc: 'https://rc-apilineage.plaync.com/api/main/cnb/userData',
  live: 'https://api-lineage.plaync.com/api/main/cnb/userData'
};

const lineage2 = {
  local: null,
  rc: 'https://rc-api-lineage2.plaync.com/cnb/user',
  live: 'https://api-lineage2.plaync.com/cnb/user'
};

const aion = {
  local: null,
  rc: 'https://rc-api-aion.plaync.com/webcontents/v2/cnb/userData',
  live: 'https://api-aion.plaync.com/webcontents/v2/cnb/userData'
};

const bns = {
  local: null,
  rc: 'https://rc-api-bns.plaync.com/web/v2/cnb/userData',
  live: 'https://api-bns.plaync.com/web/v2/cnb/userData'
};

export default {
  lineage,
  lineage2,
  aion,
  bns
};

